import { connect } from "react-redux";
import ProductLayoutList from "../components/ProductLayoutList";
import { bindActionCreators } from "redux";

const mapStateToProps = (state, ownProps) => {
  const product = state.products.filter((p) => p.id == ownProps.product_id)[0];
  return Object.assign({}, ownProps, { product: product });
};

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

const ProductContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ProductLayoutList);

export default ProductContainer;
